import { useContext } from "react";

import { Home } from "./Default/Home";
import { HomeScreen } from "../../../modules/Home/HomeScreen";
import { SalesRecomendation } from '../../../modules/PurchaseManagementModule/SalesRecomendation/SalesRecommendation'
import { AssortmentScreen } from '../../../modules/Assortment/AssortmentScreen'
import { MerchandiseOptions } from '../../../modules/Assortment/MerchandiseOptions'
import { OpportunityInsightsScreen } from '../../../modules/AnalysisModule/OpportunityInsights/OpportunityInsightsScreen'
import { PlanoDeCompraScreen } from "../../../modules/OtbPlanning/PlanoDeCompraScreen";

import { TenantContext } from "../../../templates/context/TenantContext";

import { textFormatter } from "../../../utils/formatter/formatter";

// home somente em homologação
const allowHome = true

export const HOME_STRATEGY_CONSTANTS = Object.freeze({
  ALDO: 'aldo',
  BESNI: 'besni',
  BUFFON: 'buffon',
  CAEDU: 'caedu',
  CENTERSHOP: 'centershop',
  DEMO: 'demo',
  DEFAULT: 'default',
  GRAZZIOTIN: 'grazziotin',
  ROVITEX: 'rovitex'
});

const homeStrategySelector = ({ tenant }) => {
  switch (tenant) {
    case HOME_STRATEGY_CONSTANTS.ALDO:
      return allowHome ? HomeScreen : PlanoDeCompraScreen;

    case HOME_STRATEGY_CONSTANTS.BESNI:
      return allowHome ? HomeScreen : OpportunityInsightsScreen;

    case HOME_STRATEGY_CONSTANTS.BUFFON:
      return allowHome ? HomeScreen : SalesRecomendation      

    case HOME_STRATEGY_CONSTANTS.CAEDU:
      return allowHome ? HomeScreen : OpportunityInsightsScreen

    case HOME_STRATEGY_CONSTANTS.CENTERSHOP:
      return allowHome ? HomeScreen : MerchandiseOptions

    case HOME_STRATEGY_CONSTANTS.DEMO:
      return allowHome ? HomeScreen : HomeScreen;

    case HOME_STRATEGY_CONSTANTS.GRAZZIOTIN:
      return allowHome ? HomeScreen : OpportunityInsightsScreen      

    case HOME_STRATEGY_CONSTANTS.ROVITEX:
      return allowHome ? HomeScreen : AssortmentScreen;      

    default:
      return Home;
  }
};

export const HomeStrategy = ({ mode }) => {
  const { tenant } = useContext(TenantContext);

  const resolvedTenant = mode ?? textFormatter(tenant, { textTransform: 'lowercase' });
  if (!resolvedTenant) return null; 

  const StrategyComponent = homeStrategySelector({ tenant: resolvedTenant });
  return <StrategyComponent />;
};